<template>
  <div class="flex">
    <el-table
      :data="list"
      height="100%"
      style="width: 100%">
      <el-table-column
        prop="cluesName"
        align="center"
        label="考察人">
      </el-table-column>
      <el-table-column
        prop="cluesCompany"
        align="center"
        label="公司">
      </el-table-column>
      <el-table-column
        prop="isLeader"
        align="center"
        label="是否主要领导">
        <template slot-scope="{row}">
          <span>{{ row.isLeader ? '是' : '否' }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    isCurrentTab: Boolean,
    list: Array,
  },
};
</script>

<style>

</style>
